// extracted by mini-css-extract-plugin
export var carousel = "Carousel-module--carousel--1ze3w";
export var mainHeading = "Carousel-module--main-heading--1ZPVW";
export var content = "Carousel-module--content--2qV48";
export var item = "Carousel-module--item--ZZNv8";
export var eyebrowText = "Carousel-module--eyebrow-text--1QZQh";
export var green = "Carousel-module--green--2Orfu";
export var pink = "Carousel-module--pink--3YIkl";
export var blue = "Carousel-module--blue--1t56r";
export var purple = "Carousel-module--purple--2hKi2";
export var heading = "Carousel-module--heading--1jPu3";
export var number = "Carousel-module--number--2QWqQ";
export var description = "Carousel-module--description--1Igq2";
export var showProgress = "Carousel-module--show-progress--2C9xl";
export var show = "Carousel-module--show--vz5LF";
export var hide = "Carousel-module--hide--ZI845";
export var image = "Carousel-module--image--3tZTx";
export var cta = "Carousel-module--cta--1V5gX";
export var open = "Carousel-module--open--15g2N";
export var collapse = "Carousel-module--collapse--1Fac5";